import { useNavigate } from 'react-router-dom';

import { ReactComponent as HelpSVG } from 'assets/help_outline.svg';
import { ReactComponent as LogoSVG } from 'assets/logo.svg';

function Header() {
  const navigate = useNavigate();
  const switchPage = (link: string) => {
    navigate(link)
  }

  return (
    <>
    <div className="top-banner">
      <a href="https://forms.gle/skYaq8VmMC2tiZru7" target="_blank">Would you like to report a bug? <span>Click Here</span></a>
    </div>
    <header className="border-0 border-b border-solid border-[#464646] flex justify-center">
      <div className="max-w-[1024px] px-6 justify-between items-center flex h-[50px] w-full">
        <LogoSVG className="cursor-pointer" onClick={() => switchPage('/')} />
        <div className="flex items-center">
       <div className="mr-4 cursor-pointer md:hidden" onClick={() => switchPage('/')}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
          </svg>
        </div>
        <div className="cursor-pointer md:block hidden text-sm mr-12" onClick={() => switchPage('/')}>
          Home
        </div>
        <HelpSVG className="cursor-pointer md:hidden" width="24" height="24" onClick={() => switchPage('/about')} />
        <div className="cursor-pointer md:block hidden text-sm" onClick={() => switchPage('/about')}>
          How to Play?
        </div>
        </div>
      </div>
    </header>
    </>
  );
}

export default Header